import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-check-safacoins-code',
  templateUrl: './check-safacoins-code.component.html',
  styleUrls: ['./check-safacoins-code.component.scss']
})
export class CheckSafacoinsCodeComponent implements OnInit {
  codesForm: FormGroup;
  coinsData: any[] = [];
  userTransactions: any[] = [];
  userData: any[] = [];
  brands: { id: string, name: string }[] = [];
  isLoading = false;
  displayedColumns: string[] = ['photo', 'name', 'gender', 'age', 'date'];

  constructor(
    private fb: FormBuilder,
    private firebaseService: DataService
  ) { 
    this.codesForm = this.fb.group({
      brandId: ['', Validators.required]
    });
  }

 async ngOnInit() {
    this.isLoading = true;
    try {
      const brandIds = await this.firebaseService.getBrandIds();
      for (const id of brandIds) {
        const name = await this.firebaseService.getBrandNameById(id);
        this.brands.push({ id, name });
      }
    } finally {
      this.isLoading = false;
    }
  }

  async checkBrandId() {
    this.isLoading = true;
    const brandId = this.codesForm.get('brandId')?.value;
    if (brandId) {
      try {
        this.coinsData = await this.firebaseService.getCoinsData(brandId);
        this.userTransactions = await this.firebaseService.getUserTransactions(brandId);
        this.userData = [];
        for (const transaction of this.userTransactions) {
          const userDetails = await this.firebaseService.getUserDetails(transaction.userId);
          this.userData.push({
            ...userDetails,
            timestamp: new Date(transaction.timestamp?.seconds * 1000)
          });
        }
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
}